import { getRecordIdentity } from 'lib/DataModel'
import PromisedResource from './PromisedResource'

export default class CurrentUserResource extends PromisedResource {
  constructor({ remote }) {
    super(remote.query(q => q.findRecord(getRecordIdentity('user', 'me'))))
  }
}
